export default function buildQueryString(obj: Record<string, string | number | boolean | undefined>) {
  return Object.entries(obj).reduce((queryString, [key, val]) => {
    if (val === '' || val === undefined) return queryString;
    queryString += (queryString.startsWith('?') ? '&' : '?') + `${key}=${val}`;
    return queryString;
  }, '');
}
